'use strict';

/**
 * @ngdoc service
 * @name webAgro1App.KNOTS_TO_KM_H
 * @description
 * # KNOTS_TO_KM_H
 * Constant in the webAgro1App.
 */
angular.module('webAgro1App')
  .constant('KNOTS_TO_KM_H', 1.852);
